import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { SOption, SSelect } from '@strana-artw/ui-kit';
import { YM_HIDE_CONTENT } from '@/shared/constants';
export default {
  name: 'Autocomplete',
  components: {
    SSelect: SSelect,
    SOption: SOption
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    items: {
      type: Object,
      default: function _default() {
        return {
          type: {},
          result: []
        };
      }
    },
    label: {
      type: String,
      default: 'Поиск по имени или телефону'
    }
  },
  setup: function setup() {
    return {
      YM_HIDE_CONTENT: YM_HIDE_CONTENT
    };
  },
  computed: {
    itemsMapped: function itemsMapped() {
      var _this$items,
        _this = this;
      if (!((_this$items = this.items) !== null && _this$items !== void 0 && _this$items.result)) {
        return [];
      }
      if (this.items.result.length === 1) {
        if (this.items.result[0][this.itemText] === this.internalValue) {
          return [];
        }
      }
      return this.items.result.map(function (item) {
        return {
          id: item.id,
          value: item[_this.itemText]
        };
      });
    },
    internalValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('change', val);
      }
    },
    itemText: function itemText() {
      var _this$items2;
      var val = (_this$items2 = this.items) === null || _this$items2 === void 0 || (_this$items2 = _this$items2.type) === null || _this$items2 === void 0 ? void 0 : _this$items2.value;
      if (val && val === 'name') {
        return 'fio';
      }
      return val;
    }
  }
};